import { render } from "./MarcaVeiculo.vue?vue&type=template&id=67343024"
import script from "./MarcaVeiculo.vue?vue&type=script&lang=js"
export * from "./MarcaVeiculo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__